import styles from "@/styles/containers/product-details.module.scss";
import { CatalogHelpers, Currency } from "@/tools";

import { Checkbox, Radio } from "@/components";
import classNames from "classnames/bind";
import { useEffect, useRef } from "react";
import { MinusPlus } from "./MinusPlus";
import { useLocale } from "next-intl";
const css = classNames.bind(styles);

const Canvas = ({ imageUrl, isZoomable = false }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const img = new Image();

    img.onload = function () {
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      if (!isZoomable && (img.naturalWidth >= 2500 || img.naturalHeight >= 2500)) {
        canvas.width = img.naturalWidth / 5;
        canvas.height = img.naturalHeight / 5;
      }

      context.drawImage(img, 0, 0, canvas.width, canvas.height);
    };

    img.src = imageUrl;
  }, [imageUrl, isZoomable]);

  return <canvas ref={canvasRef} />;
};

export const OptionItem = ({
  option,
  onClick,
  sameOptions,
  singleOption,
  disabled,
}) => {
  const locale = useLocale();

  return (
    <div
      className={css({ optionItem: true })}
      onClick={() =>
        (!disabled || (!sameOptions && option.selected) || singleOption) &&
        onClick &&
        onClick(option)
      }
    >
      <div
        className={css({
          "d-flex": true,
          "flex-col": true,
        })}
      >
        <p className={styles.optionName}>
          {CatalogHelpers.getTranslation({
            item: option,
            field: "name",
            locale,
          })}
        </p>
        {option?.description && (
          <p className={styles.description}>
            {CatalogHelpers.getTranslation({
              item: option,
              field: "description",
              locale,
            })}
          </p>
        )}
        {option.old_price || option.price ? (
          <div className="d-flex align-center mt-10">
            {option.promo_price ? (
              <p className={styles.optionOldPrice}>
                {Currency.formatCurrency(option.old_price || 0)}
              </p>
            ) : null}
            {Number(option.price > 0) ? (
              <p className={styles.optionPrice}>
                {Currency.formatCurrency(option.price || 0)}
              </p>
            ) : null}
          </div>
        ) : null}
      </div>

      <div className={styles.optionSelect}>
        {option.image && (
          <div className={styles.image}>
            <Canvas
              imageUrl={`${process.env.NEXT_PUBLIC_CDN_ASSETS}/${option.imageZoomable || option.image}`}
              isZoomable={!!option.imageZoomable}
            />
          </div>
        )}

        {sameOptions && (
          <MinusPlus
            value={option.quantity || 0}
            disabledMax={disabled}
            onChange={(newValue) => {
              onClick && onClick({ ...option, quantity: newValue });
            }}
            hasQuantity={option?.quantity > 0}
          />
        )}
        {!sameOptions && singleOption && (
          <Radio
            key={Math.random()}
            value={option.id}
            checked={option.selected && option.id}
            readOnly
          />
        )}
        {!sameOptions && !singleOption && (
          <Checkbox
            key={Math.random()}
            value={option.id}
            checked={option.selected}
            readOnly
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};
